import React, { useEffect, useLayoutEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { connect } from "react-redux";
import imagesLoaded from "imagesloaded";
import { useParams } from "react-router-dom";

//Import Store
import store from "../../../store";

//Import Action
import {
  getProductBySlug,
  // getProductLastPrice,
  // getProductPriceHistory,
} from "../../../action/products";
// import { getProductBySlug, getProductImages } from '../../../action/products';

//Import Utils
// import { findProductById } from '../../../utils';
// import { ViewContentTracking } from "../../../utils/facebookPixelEvent";

//Import Custom Compoenet
import Breadcrumb from "../../common/breadcrumb";
import SingleDetailDesktop from "./common/details/single-detail-desktop";
import SingleDetailMobile from "./common/details/single-detail-mobile";
// import FeaturedProductsOne from './common/product-groups/featured-products-one';
import ProductSidebarOne from "./common/sidebars/product-sidebar-one";
// import SidebarToggle from './common/sidebars/sidebar-toggle';
import SingleTab from "./common/tabs/single-tab";
import HorizontalThumbnail from "./common/thumbnails/horizontal-thumbnail";
import useViewport from "../../features/useViewport";
import toTop from "../../features/toTop";

//Import Demo Products
import DemoProduct from "../../../mock-data/demo-product.json";

function DefaultProduct(props) {
  let params = useParams();
  // const { productPriceHistory, productLastPrice } = props;
  const { product_slug, category_slug } = params;
  const [productBySlug, setProductBySlug] = useState(null);
  const [colorCode, setColorCode] = useState(null);
  const { width } = useViewport();
  const breakpoint = 992;
  const crumbs = [
    {
      name: `${category_slug}`,
      path: `${process.env.PUBLIC_URL}/produkty/${category_slug}`,
    },
    {
      name: `${product_slug}`,
      path: `${process.env.PUBLIC_URL}/produkty/${category_slug}/${product_slug}`,
      style: "disabled",
    },
  ];
  useLayoutEffect(() => {
    if (document.querySelector(".skeleton-body.loaded")) {
      document.querySelector(".skeleton-body").classList.remove("loaded");
    }
  }, []);

  // const [dataProduct, setDataProduct] = useState(null);

  useLayoutEffect(() => {
    let imgLoad = imagesLoaded(".product-single-gallery");

    imgLoad.on("done", function () {
      if (document.querySelector(".skeleton-body") && productBySlug) {
        document.querySelector(".skeleton-body").classList.add("loaded");
      }
    });
  }, [productBySlug]);

  // useEffect(() => {
  //   if (productBySlug) {
  //     ViewContentTracking(productBySlug);
  //   }
  // }, [productBySlug]);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    store.dispatch(getProductBySlug(product_slug, setProductBySlug));
  }, [product_slug]);

  // useEffect(() => {
  //   if (productBySlug) {
  //     store.dispatch(
  //       getProductLastPrice(
  //         productBySlug.product
  //           ? productBySlug.product_variant_sku
  //           : productBySlug.product_sku
  //       )
  //     );
  //     store.dispatch(
  //       getProductPriceHistory(
  //         productBySlug.product
  //           ? productBySlug.product_variant_sku
  //           : productBySlug.product_sku
  //       )
  //     );
  //   }
  // }, [productBySlug]);

  // const [img, setImg] = useState([]);

  // useEffect(() => {
  //   if(productBySlug) {
  //     store.dispatch(getProductImages(productBySlug.product_id, setImg));
  //   }
  // }, [productBySlug]);

  useEffect(() => {
    if (productBySlug) {
      setIsLoading(false);
    }
  }, [productBySlug]);

  useEffect(() => {
    setTimeout(() => {
      toTop();
    }, 100);
  }, [params.product_slug]);

  useEffect(() => {
    if (colorCode) {
      setProductBySlug({
        ...productBySlug,
        color_code: colorCode,
      });
    }
  }, [colorCode]);

  return (
    <>
      <Helmet>
        <title>
          {productBySlug
            ? productBySlug.product
              ? productBySlug.product_variant_name
              : productBySlug.product_name
            : ""}{" "}
          - Buduj.pl
        </title>
        <meta
          name="title"
          content={
            productBySlug
              ? productBySlug.product
                ? productBySlug.product_variant_meta_title
                : productBySlug.product_meta_title
              : ""
          }
        />
        <meta
          name="description"
          content={
            productBySlug
              ? productBySlug.product
                ? productBySlug.product_variant_meta_description
                : productBySlug.product_meta_description
              : ""
          }
        />
        <meta
          name="keywords"
          content={
            productBySlug
              ? productBySlug.product
                ? productBySlug.product_variant_meta_keywords
                : productBySlug.product_meta_keywords
              : ""
          }
        />
      </Helmet>

      <div className="main" itemScope itemType="http://schema.org/Product">
        <Breadcrumb crumbs={crumbs} addClass="mb-2" />

        <div className="container">
          <div className="row skeleton-body skel-shop-products">
            <div className="col-lg-9 product-page">
              <div className="product-single-container product-single-default">
                <div className="row">
                  <div className="col-12 product-title-mobile">
                    <div className="product-single-details">
                      <h1 className="product-title">
                        {productBySlug
                          ? productBySlug.product
                            ? productBySlug.product_variant_name
                            : productBySlug.product_name
                          : null}
                      </h1>
                    </div>
                  </div>

                  {!isLoading ? (
                    <HorizontalThumbnail
                      addClass="col-lg-5 col-md-5"
                      dataProduct={productBySlug}
                    />
                  ) : null}

                  <div className="col-lg-7 col-md-7">
                    {isLoading ? (
                      width < breakpoint ? (
                        <SingleDetailMobile
                          dataProduct={DemoProduct}
                          isLoading={isLoading}
                          // productPriceHistory={productPriceHistory}
                          // productLastPrice={productLastPrice}
                          {...props}
                        />
                      ) : (
                        <SingleDetailDesktop dataProduct={DemoProduct} />
                      )
                    ) : width < breakpoint ? (
                      <SingleDetailMobile
                        dataProduct={productBySlug}
                        isLoading={isLoading}
                        // productPriceHistory={productPriceHistory}
                        // productLastPrice={productLastPrice}
                        category_slug={category_slug}
                        setColorCode={setColorCode}
                        colorCode={colorCode}
                        {...props}
                      />
                    ) : (
                      <SingleDetailDesktop
                        dataProduct={productBySlug}
                        category_slug={category_slug}
                        setColorCode={setColorCode}
                      />
                    )}
                  </div>
                </div>
              </div>

              {isLoading ? (
                <SingleTab dataProduct={DemoProduct} isLoading={isLoading} />
              ) : (
                <SingleTab dataProduct={productBySlug} isLoading={isLoading} />
              )}

              {/* {
                (productBySlug && productBySlug.related.length || productBySlug && productBySlug.product && productBySlug.product.related.length ) ? 
                  <FeaturedProductsOne addClass="pt-5 mb-5" dataProduct={productBySlug} />
                : null
              } */}
            </div>

            {/* <SidebarToggle /> */}
            {isLoading ? (
              width < breakpoint ? null : (
                <ProductSidebarOne
                  dataProduct={DemoProduct}
                  isLoading={isLoading}
                  // productPriceHistory={productPriceHistory}
                  // productLastPrice={productLastPrice}
                  {...props}
                />
              )
            ) : width < breakpoint ? null : (
              <ProductSidebarOne
                dataProduct={productBySlug}
                isLoading={isLoading}
                // productPriceHistory={productPriceHistory}
                // productLastPrice={productLastPrice}
                colorCode={colorCode}
                {...props}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    productBySlug: state.products.productBySlug
      ? state.products.productBySlug
      : null,
    productPriceHistory: state.products.productPriceHistory
      ? state.products.productPriceHistory
      : [],
    productLastPrice: state.products.productLastPrice
      ? state.products.productLastPrice
      : null,
  };
};

export default connect(mapStateToProps)(DefaultProduct);
